import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  usersListContainer: {
    width: "100%",
    height: "calc(100% - 50px)",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  leftContainer: {
    height: "100%",
    width: "100%",
    flexShrink: 0,
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "300px",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      // height: "600px",
      height: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "50px",
      backgroundColor: "#17A5B1",
    },
  },
  leftContainerExpanded: {
    height: "auto",
    // height: "100%",
    // width: "25%",
    // flexShrink: 0,
    // backgroundColor: "#17A5B1",
    // [theme.breakpoints.down("md")]: {
    //   width: "100%",
    //   height: "637px",
    // },
  },
  rightContainer: {
    flex: 1,
    overflowX: "auto",
    overflowY: "hidden",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}))

export default styles
